import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Was im E-Book enthalten ist" className="bg-transparent" data-id="element-218" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-219" data-mp="1c5grls4bwfws">
        <div className="text-center" data-id="element-220" data-mp="1zvb3o7gtq0fz">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-221" data-mp="1zwcov4rk03bf">
            🏥 REHA-CODE 360° — DAS SYSTEM FÜR DIE KLINISCHE REHABILITATION
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-grape sm:text-4xl" data-id="element-222" data-mp="1quwhz6zy6jby">
            Was erwartet Sie?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-223" data-mp="1vrwkj7xl93yb">
            6 umfassende Bände · Über 160 Seiten — Alles an einem Ort.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-224" data-mp="keaxbsbahcff">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-225" data-mp="kby6sqrgttqr">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-226" data-mp="20ynnso0gjlj">
            📚 Die 6-Bände-Methode
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-227" data-mp="3t5yep78zfgdb">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-228" data-mp="aztu95uyvvpd" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-229" data-mp="ps3z7vmx4pq1">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-230" data-mp="wu96yh0z4lh7">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-231" data-mp="16r58u3wda9cs">
                  <span aria-hidden="true" data-id="element-232" data-mp="1bivlwhmovb7w">{t.emoji} </span>
                  BAND {t.n}: {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-233" data-mp="1fjz2x7gh3dap">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-234" data-mp="1kl4taymnuoh2">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-235" data-mp="1pgbu9yojpf2a">
            ✅ Jeder Band enthält
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-236" data-mp="3r9rot6nr7e2j">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-237" data-mp="36yjp5iwa6k">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-238" data-mp="2ddq9ephl98ex" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}